import { Sort } from '@angular/material/sort';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ICreateGroupMemberActionPayload } from '../../group-member/interfaces/create-group.action.payload.interface';
import { ModuleGroupMember } from '../models/module-group-member.model';

export class SetModuleGroupMember {
    static readonly type = '[ModuleGroupMember] SetModuleGroupMember';

    constructor(public payload: ModuleGroupMember) {}
}

export class UnsetModuleGroupMember {
    static readonly type = '[ModuleGroupMember] UnsetModuleGroupMember';
}

export class FetchModuleGroupMember {
    static readonly type = '[ModuleGroupMember] FetchModuleGroupMember';

    constructor(public payload: string) {}
}

export class FetchModuleGroupMemberSuccess {
    static readonly type = '[ModuleGroupMember] FetchModuleGroupMemberSuccess';

    constructor(public payload: ModuleGroupMember) {}
}

export class FetchModuleGroupMemberFailure {
    static readonly type = '[ModuleGroupMember] FetchModuleGroupMemberFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class UpdateModuleGroupMember {
    static readonly type = '[ModuleGroupMember] UpdateModuleGroupMember';

    constructor(
        public payload: {
            isAdmin: boolean;
            memberId: string;
        }
    ) {}
}

export class UpdateModuleGroupMemberSuccess {
    static readonly type = '[ModuleGroupMember] UpdateModuleGroupMemberSuccess';

    constructor(public payload: ModuleGroupMember) {}
}

export class UpdateModuleGroupMemberFailure {
    static readonly type = '[ModuleGroupMember] UpdateModuleGroupMemberFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class CreateModuleGroupMember {
    static readonly type = '[ModuleGroupMember] CreateModuleGroupMember';

    constructor(public payload: ICreateGroupMemberActionPayload) {}
}

export class CreateModuleGroupMemberSuccess {
    static readonly type = '[ModuleGroupMember] CreateModuleGroupMemberSuccess';

    constructor(public payload: ModuleGroupMember[]) {}
}

export class CreateModuleGroupMemberFailure {
    static readonly type = '[ModuleGroupMember] CreateModuleGroupMemberFailure';
}

export class DeleteModuleGroupMember {
    static readonly type = '[ModuleGroupMember] DeleteModuleGroupMember';

    constructor(public payload: string) {}
}

export class DeleteModuleGroupMemberSuccess {
    static readonly type = '[ModuleGroupMember] DeleteModuleGroupMemberSuccess';

    constructor(public payload: string) {}
}

export class DeleteModuleGroupMemberFailure {
    static readonly type = '[ModuleGroupMember] DeleteModuleGroupMemberFailure';
}

export class ToggleSelectedModuleGroupMember {
    static readonly type = '[ModuleGroupMember] ToggleSelectedModuleGroupMember';

    constructor(public payload: string) {}
}

export class SelectFilteredModuleGroupMembers {
    static readonly type = '[ModuleGroupMember] SelectFilteredModuleGroupMembers';
}

export class DeselectSelectedModuleGroupMembers {
    static readonly type = '[ModuleGroupMember] DeselectSelectedModuleGroupMembers';
}

export class SearchModuleGroupMembers {
    static readonly type = '[ModuleGroupMember] SearchModuleGroupMembers';

    constructor(public payload: string) {}
}

export class SortModuleGroupMembers {
    static readonly type = '[ModuleGroupMember] SortModuleGroupMembers';

    constructor(public payload: Sort) {}
}

export class RefreshModuleGroupMembersOnlineState {
    static readonly type = '[GroupMember] RefreshModuleGroupMembersOnlineState';

    constructor(public payload?: ModuleGroupMember[]) {}
}
